import { DeviceType, Platform } from '../types';

export function findPlatformType(height: string, deviceType?: DeviceType): Platform {
  if (deviceType === 'mobile') {
    return 'phone';
  }

  if (parseInt(height, 0) < 580) {
    return 'small-tablet';
  }

  return 'tablet';
}
